import { memo } from 'react';

import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { FieldContainerStyled, TextareaStyled } from './TransactionDescription.styles';

const TransactionDescription = ({ title, value, placeholder, maxLength, onBlur, disabled }) => (
  <Stack spacing="8px">
    <Text
      color="primary"
      size="md"
      weight="medium"
    >
      {title}
    </Text>
    <FieldContainerStyled
      sx={(theme) => ({
        backgroundColor: theme.palette.background.grey.light
      })}
    >
      <Stack spacing="16px">
        <TextareaStyled
          aria-label="transaction description"
          defaultValue={value}
          disabled={disabled}
          maxLength={maxLength}
          minRows={2}
          onBlur={onBlur}
          placeholder={placeholder}
        />
      </Stack>
      {maxLength && (
        <Box ml="12px">
          <Text size="sm">{`${maxLength} characters max`}</Text>
        </Box>
      )}
    </FieldContainerStyled>
  </Stack>
);

TransactionDescription.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool
};

TransactionDescription.defaultValue = {
  placeholder: '',
  maxLength: 0,
  value: '',
  disabled: false
};

export default memo(TransactionDescription);
